import { Component, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { Overlay } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material';

import { AutocompleteSelectFieldComponent } from './autocomplete-select-field.component';
import { WorkflowsService } from '../workflows/workflows.service';

@Component({
  selector: 'app-jellyroll-filename-field',
  templateUrl: './autocomplete-select-field.component.html',
  styleUrls: ['./autocomplete-select-field.component.scss']
})
export class JellyrollFilenameField extends AutocompleteSelectFieldComponent {

  debounce: number = 400;
  subscription: Subscription;

  constructor(
    cd: ChangeDetectorRef,
    dialog: MatDialog,
    overlay: Overlay,
    private workflowsService: WorkflowsService) { super(cd, dialog, overlay); }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.subscription != null) {this.subscription.unsubscribe()}
  }

  setMatchRegex(value) {
    this.matchRegex = new RegExp('(' + value.regExpEscape() + ')', 'gi');
  }

  loadSuggestions(value) {
    if (this.subscription != null) {this.subscription.unsubscribe()}
    if (value != null && value.trim() !== '') {
      this.subscription = this.workflowsService.getJellyrollFilenames(value, 8).subscribe(
        (data: any) => {
          this.suggestions = data.map((t) => {
            return {
              displayed: t.filename,
              stored: t.item_id
            }
          })
          if (this.suggestions.length > 0) {
            this.selectedIndex = 0;
            this.showSuggestions();
          }
          this.loading = false;
          this.cd.markForCheck();
        },
        (errors) => {this.loading = false; this.cd.markForCheck();}
      )
    } else {
      this.loading = false;
      this.cd.markForCheck();
    }
  }

  commitSelected() {
    if (this.subscription != null) {this.subscription.unsubscribe()}
    this.loading = false;
    this.cd.markForCheck();
    super.commitSelected();
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/jellyroll-filename-field.component.ts